export default {
  state: {
    editorPickedColor: {},
    editorPickedColorNombre: {},
    editorPickedIcon: {}
  },

  getters: {
    getEditorPickedColor (state) {
      return state.editorPickedColor
    },

    getEditorPickedColorNombre (state) {
      return state.editorPickedColorNombre
    },

    getEditorPickedIcon (state) {
      return state.editorPickedIcon
    }
  },

  mutations: {
    setEditorPickedColor (state, editorPickedColor) {
      state.editorPickedColor = editorPickedColor
    },

    setEditorPickedColorNombre (state, editorPickedColorNombre) {
      state.editorPickedColorNombre = editorPickedColorNombre
    },

    setEditorPickedIcon (state, editorPickedIcon) {
      state.editorPickedIcon = editorPickedIcon
    },

    unsetEditorPickedColor (state) {
      state.editorPickedColor = {}
    },

    unsetEditorPickedColorNombre (state) {
      state.editorPickedColorNombre = {}
    },

    unsetEditorPickedIcon (state) {
      state.editorPickedIcon = {}
    }
  }
}
